import React from 'react';

/**
 * Placeholder grid cell matching product tile aspect ratio (CLS).
 * count: number of skeleton cards to render.
 */
function ProductCardSkeleton({ count = 6, className = '' }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`product-skeleton-${index}`}
          className={`product-default product-card-skeleton ${className}`.trim()}
          aria-hidden="true"
        >
          <figure className="product-card-skeleton__figure">
            <div className="product-card-skeleton__box" />
          </figure>
          <div className="product-details product-card-skeleton__details">
            <div className="product-card-skeleton__line product-card-skeleton__line--title" />
            <div className="product-card-skeleton__line product-card-skeleton__line--meta" />
          </div>
        </div>
      ))}
    </>
  );
}

export default ProductCardSkeleton;
